import Vue from 'vue'
import store from '../../store'
import App from './index.vue'

Vue.config.productionTip = false;
var _thisVue = new Vue({
	store,
	render: h => h(App)
});
_thisVue.$mount('#supplier');
